<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增成员"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="姓名" prop="user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入成员姓名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" placeholder="请输入联系电话" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" autocomplete="new-password"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="verifyPass">
                <el-input type="password" v-model="ruleForm.verifyPass" placeholder="请输入确认密码"
                          autocomplete="new-password" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属公司" prop="company_id">
                <el-select :disabled="companyDisabled" @change="changeCompany" v-model="ruleForm.company_id"
                           placeholder="请选择所属公司"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属部门" prop="department_id">
                <el-select :disabled="departmentDisabled" @change="changeDepartment" v-model="ruleForm.department_id" placeholder="请选择所属部门"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allDepartment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属组" prop="group_id">
                <el-select :disabled="groupDisabled" @change="changeGroup" v-model="ruleForm.group_id" placeholder="请选择所属组"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="职务">-->
<!--                <el-input type="text" v-model="ruleForm.posistion" placeholder="请输入职务" autocomplete="off"-->
<!--                          style="width: 100%;" ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="职称">-->
<!--                <el-input type="text" v-model="ruleForm.user_title" placeholder="请输入职称（限6字）" autocomplete="off"-->
<!--                          style="width: 100%;" maxlength="6"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="简介">
                <el-input type="textarea" v-model="ruleForm.introduction" maxlength="85"
                          show-word-limit
                          autosize placeholder="请输入简介" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="分配特属专家" prop="doctor_ids">
                <el-select v-model="ruleForm.doctor_ids"
                           multiple
                           placeholder="请选择负责特属专家"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allDoctors"
                        :key="item.user_id"
                        :label="item.doctor_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="头像">
                <div class="avatar-uploader">
                    <label class="avatar-btn" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import md5 from "js-md5";
    import {VueCropper} from "vue-cropper";
    import {isMobile} from "@/api/order";

    export default {
        components: {
            VueCropper
        },
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
            if (this.$route.params.company_id) {
                this.ruleForm.company_id = this.$route.params.company_id
                this.companyDisabled = true;
                this.changeCompany()
            }
            if (this.$route.params.department_id) {
                this.ruleForm.department_id = this.$route.params.department_id
                this.deparmentDisabled = true;
                this.changeDepartment()
            }
            if (this.$route.params.group_id) {
                this.ruleForm.group_id = this.$route.params.group_id
                this.groupDisabled = true;
                this.changeGroup()
            }
        },
        mounted() {
            this.getCompany();
        },
        data() {
            // 验证账户
            var checkAccount = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/[a-zA-Z]/).test(value.slice(0, 1))) {
                        callback(new Error('用户名必须以英文字母开头，包含字母与数字，长度不超过32位'));
                    } else {
                        if (!(/^[0-9a-zA-Z]{1,}$/).test(value)) {
                            callback(new Error('用户名必须以英文字母开头，包含字母与数字，长度不超过32位'));
                        } else {
                            callback();
                        }
                    }
                }, 1);
            };

            // 验证密码
            var checkPassword = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^[0-9a-zA-Z_！@#￥%\.&\*]{6,16}$/).test(value)) {
                        callback(new Error('密码可由数字、字母和下划线组成，长度6-16位'));
                    } else {
                        callback();
                    }
                }, 1);
            };
            // 验证手机
            var checkMobil = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^1[3456789]\d{9}$/).test(value)) {
                        callback(new Error('输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 1);
            };
            // 验证确认密码
            var checkVerifyPass = (rule, value, callback) => {
                setTimeout(() => {
                    if (value != this.ruleForm.password) {
                        callback(new Error('密码与确认密码不一致'));
                    } else {
                        callback();
                    }
                }, 1);
            };
            return {
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
                userAvaratImageUrl: '',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                loading: false,
                dialogVisible: false,
                option: {
                    img: '',             //裁剪图片的地址
                },
                allCompany: [],
                allDepartment: [],
                allGroup: [],
                allDoctors: [],
                companyDisabled: false,
                departmentDisabled: false,
                groupDisabled: false,
                ruleForm: {
                    user_name: "",
                    user_avatar: '',
                    mobile: "",
                    password: "",
                    verifyPass:"",
                    company_id: "",
                    department_id: "",
                    group_id: "",
                    doctor_ids: [],
                    status: 1,
                    introduction: '',
                    posistion: '',
                    user_title: '',
                },
                rules: {
                    account: [
                        {required: true, message: "用户名必须以英文字母开头，包含字母与数字，长度不超过32位", trigger: "blur"},
                        {max: 32, message: "用户必须以英文字母开头，包含字母与数字，长度不超过32位", trigger: "blur"},
                        {validator: checkAccount, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: "密码可由数字、字母和下划线组成，长度6-16位", trigger: "blur"},
                        {min: 6, max: 16, message: "密码可由数字、字母和下划线组成，长度6-16位", trigger: "blur"},
                        {validator: checkPassword, trigger: 'blur'}
                    ],
                    verifyPass: [
                        {required: true, message: "请输入确认密码", trigger: "blur"},
                        {validator: checkVerifyPass, trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: "请输入联系电话", trigger: "blur"},
                        {min: 11, max: 11, message: "请输入正确的联系电话", trigger: "blur"},
                        {validator: checkMobil, trigger: 'blur'}
                    ],
                    user_name: [
                        {required: true, message: "请输入成员姓名", trigger: "blur"},
                    ],
                    company_id: [
                        {required: true, message: "请选择所属公司", trigger: "blur"},
                    ],
                    department_id: [
                        {required: true, message: "请选择所属部门", trigger: "blur"},
                    ],
                    group_id: [
                        {required: true, message: "请选择所属组", trigger: "blur"},
                    ],
                    posistion: [
                        {required: true, message: "请输入职称", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],

                },
                is_submit: false,
                form_width: "40%",
            };
        },
        methods: {
            // 新建时需在的数据
            getCompany() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'createCompanyDeparmentParams',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data.all_company;

                });

            },
            // 获取公司下的运营组
            changeCompany() {
                this.allCompanyDeparment=[];
                this.ruleForm.department_id = '';
                this.ruleForm.group_id = '';
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyDeparment',
                    params: {
                        status: 1,
                        company_id: this.ruleForm.company_id
                    }
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    this.allDepartment = res.data.data;
                });

            },
            // 获取运营组
            changeDepartment() {
                this.ruleForm.group_id = '';
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyGroup',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allGroup = res.data.data;
                });
            },
            // 获取还未分配服务专员的特属专家
            changeGroup() {
                this.allCompanyDeparment=[];
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllDoctor',
                    params: {
                        status: 1,
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        group_id: this.ruleForm.group_id,
                    }
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    this.allDoctors = res.data.data;
                });
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
                // window.close()
            },
            // 获取已负责的特属专家
            getUserDoctor() {
                this.allCompanyDeparment=[];
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllDoctor',
                    params: {
                        status: 1,
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        group_id: this.ruleForm.group_id,
                        operate_user_id: this.ruleForm.operate_user_id,
                    }
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    this.allDoctors = res.data.data;
                });
            },
            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'createOperateUser',
                            'params': {
                                user_name: this.ruleForm.user_name,
                                mobile: this.ruleForm.mobile,
                                status: this.ruleForm.status,
                                company_id: this.ruleForm.company_id,
                                department_id: this.ruleForm.department_id,
                                group_id: this.ruleForm.group_id,
                                password: this.ruleForm.password ? md5(this.ruleForm.password.toString()) : "",
                                doctor_ids: this.ruleForm.doctor_ids,
                                introduction: this.ruleForm.introduction,
                                user_avatar: this.ruleForm.user_avatar,
                                // posistion: this.ruleForm.posistion, // 现任
                                // user_title: this.ruleForm.user_title, // 职称
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    window.history.go(-1);
                                    _that.is_submit = false;
                                }
                            });
                        }).catch(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
            },
            //选择图片
            selectImg(e) {
                let file = e.target.files[0]

                if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                    this.$message({
                        message: '图片类型要求：jpeg、jpg、png',
                        type: "error"
                    });
                    return false
                }
                //转化为blob
                let reader = new FileReader()
                reader.onload = (e) => {
                    let data
                    if (typeof e.target.result === 'object') {
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } else {
                        data = e.target.result
                    }
                    this.option.img = data
                    this.dialogVisible = true;
                }
                //转化为base64
                reader.readAsDataURL(file)
            },
            //上传图片
            uploadImg(type) {
                let _this = this;
                if (type === 'blob') {
                    //获取截图的blob数据
                    this.$refs.cropper.getCropBlob(async (data) => {

                        let formData = new FormData();
                        formData.append('file', data, ".jpg")

                        await _this.$api.avatar_upload_file(formData).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            if (res.data.code == 0) {
                                _this.ruleForm.user_avatar = res.data.data;
                                _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                                _this.dialogVisible = false;
                            } else {
                                _this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                });
                            }
                        })

                    })
                }
            },
            // 关闭对话框清除之前选择的文件
            closeDialog() {
                document.getElementById('uploads').value = ''
                document.getElementById('suploads').value = ''
            },

        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .cropper-content {
        .cropper {
            width: auto;
            height: 300px;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-btn, .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-btn, .avatar-uploader .el-upload:hover {
        border-color: #d9d9d9;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px !important;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar-btn {
        display: inline-block;
        text-align: center;
        width: 200px;
        height: 200px;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
